import React from "react";

interface InsuranceRatingProps {
  rating?: number | null;
  maxStars?: number;
  activeColor?: string;
  inactiveColor?: string;
  size?: number | string;
  gap?: number | string;
  hideWhenEmpty?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

function InsuranceRating({
  rating,
  maxStars = 5,
  activeColor,
  inactiveColor = "#ccc",
  size = 18,
  gap = "3px",
  hideWhenEmpty = true,
  className,
  style,
}: InsuranceRatingProps) {
  const value: number | null = rating ?? null;
  const hasRating = value != null && value > 0;

  // Standard UI hides the component entirely when no rating is configured.
  if (hideWhenEmpty && !hasRating) {
    return null;
  }

  return (
    <div
      className={className}
      style={{ display: "flex", gap, ...style }}
      role="img"
      aria-label={hasRating ? `${value} / ${maxStars}` : undefined}
    >
      {Array.from({ length: maxStars }, (_, i) => i + 1).map((s) => (
        <span
          key={s}
          aria-hidden="true"
          style={{
            fontSize: size,
            color: value != null && s <= value ? activeColor : inactiveColor,
            lineHeight: "1",
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
}

export default InsuranceRating;
